// extracted by mini-css-extract-plugin
module.exports = {"floatingButton":"FloatingCartBtn_floatingButton__2wYRC","visible":"FloatingCartBtn_visible__8CLQI","badge":"FloatingCartBtn_badge__1eTo9"};